var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 40,
    width: 40,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 28.417q2.792 0 4.729-1.938 1.938-1.937 1.938-4.729 0-2.833-1.938-4.75-1.937-1.917-4.729-1.917-2.833 0-4.75 1.917-1.917 1.917-1.917 4.75 0 2.792 1.917 4.729 1.917 1.938 4.75 1.938Zm0-2.125q-1.958 0-3.25-1.292t-1.292-3.25q0-1.958 1.292-3.271 1.292-1.312 3.25-1.312t3.25 1.312q1.292 1.313 1.292 3.271T23.25 25q-1.292 1.292-3.25 1.292ZM6.792 34.167q-1.084 0-1.854-.771-.771-.771-.771-1.854V11.917q0-1.042.771-1.834.77-.791 1.854-.791h5.5l3.041-3.459h9.334l3.041 3.459h5.5q1.084 0 1.854.791.771.792.771 1.834v19.625q0 1.083-.771 1.854-.77.771-1.854.771Zm26.416-2.084q.25 0 .396-.145.146-.146.146-.396V11.917q0-.209-.146-.354-.146-.146-.396-.146H26.75l-3.042-3.5h-7.416l-3.042 3.5H6.792q-.25 0-.396.146-.146.145-.146.354v19.625q0 .25.146.396.146.145.396.145ZM20 21.75Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.56a6f4bee66bc5bd43adcdac329ffc36.svg";
export { ForwardRef as ReactComponent };